import { render, staticRenderFns } from "./ServiceOverview.vue?vue&type=template&id=f1dd4210&scoped=true&"
import script from "./ServiceOverview.vue?vue&type=script&lang=js&"
export * from "./ServiceOverview.vue?vue&type=script&lang=js&"
import style0 from "./ServiceOverview.vue?vue&type=style&index=0&id=f1dd4210&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1dd4210",
  null
  
)

export default component.exports